import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Tab from "../components/tab";
import Footer from "../components/Footer";
import {
  personal_information,
  save_personal_details,
  save_secret,
  generate_my_cv,
  updatePersonalInfo,
  sendOtp,
  personal_loading,
  resume_step_jump_function,
  returnHome,
  send_otp_loading,
  existing_resume,

} from "../../../Redux/ActionCreator";
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import SelectLanguage from "../../common/resumeLangSelection/selectLanguage";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { capitalizeWords, capitalize } from "../../../utils/capitalize/capitalizeWord";

export default function PersonalInfoPage2({ nextStep, prevStep }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const info = useSelector((info) => info.personal_info);
  const profile = useSelector((e) => e.login);
  const userInfo = useSelector((e) => e.userInfo);
  const secret = useSelector((prev) => prev.secret);
  const p_profile = useSelector((e) => e.profile);
  const existingResume = useSelector(e => e.existingCV);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [showCity, setShowCity] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);
  const [ stateError, setStateError ] = useState(false);

  useEffect(() => {
    if (info.message !== null) {
      // get the first and lastname only
      let address = info.message.Address;
      setCity(address !== undefined ? address.split(", ")[0] : "");
      setState(address !== undefined ? address.split(", ")[1] : "");
    } else {
      let cacheInfo = getOneFromServerCache("personalInfo")
      cacheInfo.then(res => res.json())
        .then(res => {
          console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(personal_information(resObj));
              setCity(resObj?.Address.split(", ")[0]);
              setState(resObj?.Address.split(", ")[1]);
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch(err => {
          // console.log("Error getting personal info", err)
        })
    }
  }, []);


  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showCityTimeout = setTimeout(() => setShowCity(true), 2500); // Matches

    return () => {
      clearTimeout(showCityTimeout)
    };
  }, []);

  useEffect(() => {
    if (city?.length > 0 && showCity !== false) {
      // Show last name label and input once first name is being typed
      const showStateTimeout = setTimeout(() => setShowState(true), 800);

      return () => clearTimeout(showStateTimeout);
    }
  }, [city, showCity]);

  useEffect(() => {
    if (showCity !== false) {
      // Show last name label and input once first name is being typed
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 400);

      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [showCity]);

    /* Moving section */
    const handlePrev = () => {
      prevStep();
    }

    const handleNextCall = async () => {
      // handleNext(dispatch, firstName, lastName, nextStep);
      try {
        if (city !== "" && state !== "") {
          let personalInformation = {
            Firstname: info.message?.Firstname,
            LastName: info.message?.LastName,
            Phone_number: info.message?.Phone_number,
            Email: info.message?.Email,
            city: capitalize(city)?.trim(),
            state: capitalize(state)?.trim(),
            Address: capitalize(city)?.trim() + ", " + capitalize(state)?.trim(),
            JobInterests: info.message?.JobInterests
          }
          dispatch(personal_information(personalInformation));
          // save into server cache
          await saveIntoServerCache("personalInfo", personalInformation);
          nextStep();
        } else {
          if (state == "") {
            setStateError(true);
          }
          setTimeout(() => {
            toast.error("City and State is required", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }, 50);
        }
      } catch (error) {
          throw error
      }
    }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] w-full gap-y-16 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md p-6 md:p-8`}>
        
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <Tab label="Personal Information" current={true} completed={false} num="1" />
            <Tab num="2" current={false} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        {/* Input Section with Animations */}
        <div className="flex justify-center w-full">
          <div className="flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center">
            
            <motion.p 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut" }} 
              className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold notranslate"
            >
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["¡Genial! ¿Cómo pueden los empleadores contactarte?"]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Awesome! How can employers contact you?"]} loop={1} typeSpeed={40} />
              )}
              {/* <Typewriter words={["Awesome! How can employers contact you?"]} loop={1} typeSpeed={50} />               */}
            </motion.p>

            <div className="flex lg:w-full zsm:w-[400px] flex-col lg:flex-row md:gap-8 md:justify-between justify-center">
              
              {/* City Input with Fade-Up & Typing Effect */}
              {showCity && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                  className="flex w-full flex-col gap-y-2  vsm:my-6 md:my-0 "
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="city" className="text-black font-medium text-sm mb-2 notranslate">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿En qué ciudad vives?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What is your city?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What is your city?"]} loop={1} /> */}
                      </label>
                      <input
                        type="text"
                        id="city"
                        className="w-full max-w-[400px] border-2 border-[#777DEA54] rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        placeholder="Buda"
                      />
                    </div>
                  </div>
                </motion.div>
              )}
              {/* State Input with Fade-Up & Typing Effect */}
              {showState  && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                  className="flex w-full flex-col gap-y-2"
                >
                  <div className="flex justify-center">
                    <div>
                      <label htmlFor="state" className="text-black font-medium text-sm mb-2">
                      {flowLanguage == "Spanish" ? (
                        <Typewriter key={flowLanguage} words={["¿En qué estado vives?"]} loop={1} typeSpeed={40} />
                      ) : (
                        <Typewriter key={flowLanguage} words={["What is your state?"]} loop={1} typeSpeed={40} />
                      )}
                        {/* <Typewriter words={["What is your state?"]} loop={1} /> */}
                      </label>
                      <input
                        type="text"
                        id="state"
                        className="w-full border-2 max-w-[400px] rounded-md py-2 px-3 border-[#777DEA54] placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        placeholder="Texas"
                      />
                      
                      {stateError && (<p className="text-xs text-[#FF6633] font-medium">Please type your state before you continue!</p>)}
                    </div>
                  </div>
                </motion.div>
              )}

            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-8 rounded-md notranslate" key={flowLanguage}
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {flowLanguage == "Spanish" ? (
                        "ANTERIOR"
                      ) : (
                        "PREVIOUS"
                      )}
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md notranslate" key={flowLanguage}
                  >
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
    </div>
  );
}
